"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalFooter = void 0;
var tslib_1 = require("tslib");
var React = (0, tslib_1.__importStar)(require("react"));
var box_1 = require("../box");
var flexbox_1 = require("../flexbox");
var padding_1 = require("../padding");
function ModalFooter(props) {
    var children = props.children, _a = props.showBorder, showBorder = _a === void 0 ? true : _a, _b = props.padding, padding = _b === void 0 ? 24 : _b;
    return (React.createElement(box_1.Box, { borderTop: showBorder ? 1 : 0 },
        React.createElement(padding_1.Padding, { size: padding },
            React.createElement(flexbox_1.Flexbox, { justifyContent: "flex-end" }, children))));
}
exports.ModalFooter = ModalFooter;
//# sourceMappingURL=index.js.map